<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCalendarMonth } from "@mdi/js";
export default {
  name: "MdiCalendarMonth",
  data() {
    return {
      svgPath: mdiCalendarMonth,
    };
  },
};
</script>
